import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Rooms } from '../models/rooms';

@Injectable({
  providedIn: 'root'
})

export class RoomsService extends CrudService<Rooms, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/rooms`);

    this._http = _http;
  }

}

